import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getBanners, Banner } from "../services/banner.service.ts";

export interface BannerState {
  items: Banner[];
  loading: string;
}

export const FetchBanners = createAsyncThunk("FetchBanners", async () => {
  const { data, error } = await getBanners();

  if (error) {
    throw new Error(error.message);
  }

  return data;
});

const bannerSlice = createSlice({
  name: "banners",
  initialState: {
    items: [],
    loading: "IDLE",
  } as BannerState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FetchBanners.pending, (state) => {
        state.loading = "PENDING";
      })
      .addCase(FetchBanners.rejected, (state) => {
        // Deliberately keeps the previous banners. A transient failure must not
        // clear a live downtime notice, and the failure itself is never shown.
        state.loading = "DONE";
      })
      .addCase(FetchBanners.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = "DONE";
      });
  },
});

export const { reducer } = bannerSlice;
